import { Container, Grid, Tab, Tabs } from "@mui/material";
import { useEffect, useMemo, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";

import { GetMarketLoggedInList } from "store/api/market";
import MarketHeader from "./Component/MarketHeader";
import MarketTabs from "./Component/TableMarket/MarketTabs";
import TableMarket from "./Component/TableMarket";
import TableSkeleton from "components/Skeletons/Table.skeleton";
import http from "config/http";
import { repeat } from "utils/helpers/interval";
import { search } from "utils/helpers/search";
import styled from "@emotion/styled";
import useIsMobileView from "hooks/useIsMobileView";
import { useIsUserBlocked } from "hooks/useIsUserBlocked";
import useNotify from "hooks/useNotify";
import { ROUTE_PATHS } from "routes/paths";

let getMarketLoggedInListInterval = null;

export function Market() {
  const notify = useNotify();
  const location = useLocation();
  const navigate = useNavigate();
  const isMobileView = useIsMobileView();
  const isUserBlocked = useIsUserBlocked();

  const [marketList, setMarketList] = useState();
  const [loading, setLoading] = useState(true);
  const [value, setValue] = useState();
  const [valueSelected, setValueSelected] = useState(-1);

  const getMarketLoggedInList = async ({ destSelected, hasLoading }) => {
    try {
      if (hasLoading) {
        setLoading(true);
      }
      const { data } = await http.get(GetMarketLoggedInList(destSelected));
      setMarketList(data?.data);
      setLoading(false);
    } catch (e) {
      notify(e?.response?.data?.message, "error");
    }
  };

  const handleChangeTab = (_, newValue) => {
    setValueSelected(newValue);
  };

  const handleChangeTabTop = (_, newValue) => {
    navigate(newValue);
  };

  const handleSearch = (e) => {
    const value = e.target.value;
    setValue(value);
  };

  const searchedMarketList = useMemo(() => {
    return search({
      list: marketList,
      value,
      keys: ["coinSourceName", "coinDestinationName"],
    });
  }, [marketList, value]);

  useEffect(() => {
    getMarketLoggedInList({ destSelected: valueSelected, hasLoading: true });

    clearInterval(getMarketLoggedInListInterval);

    getMarketLoggedInListInterval = repeat({
      action: () =>
        getMarketLoggedInList({
          destSelected: valueSelected,
          hasLoading: false,
        }),
    });

    return () => {
      clearInterval(getMarketLoggedInListInterval);
    };

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [valueSelected]);

  return (
    <Container maxWidth="100%">
      {isMobileView && (
        <Grid item xs={12} mt={3}>
          <TabsStyle value={location.pathname} onChange={handleChangeTabTop}>
            <Tab label="Exchange" value={ROUTE_PATHS.market} />
            <Tab label="P2P" value={"/p2p"} />
          </TabsStyle>
        </Grid>
      )}

      {!isUserBlocked && <MarketHeader value={value} onChange={handleSearch} />}

      <MarketTabs value={valueSelected} onChange={handleChangeTab} />

      {!loading ? (
        <TableMarket
          marketList={searchedMarketList}
          setMarketList={setMarketList}
        />
      ) : (
        <Grid container>
          <Grid item xs={12}>
            <TableSkeleton />
          </Grid>
        </Grid>
      )}
    </Container>
  );
}

const TabsStyle = styled(Tabs)(({ theme }) => ({
  borderBottom: `1px solid ${theme.palette.modules.border}`,
  ".MuiTabs-flexContainer": {
    justifyContent: "space-around",
  },
}));

export default Market;
